import { openBlock as l, createElementBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return l(), o("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.333.375c-.848 0-1.604.5-1.96 1.251-1.783 3.772-3.568 6.116-6.2 7.749H5v11.25h1.779l6.5 1.5h7.82a1.375 1.375 0 0 0 0-2.75h-.5a.625.625 0 1 1 0-1.25h1.5a1.375 1.375 0 0 0 0-2.75h-.5a.625.625 0 1 1 0-1.25h1a1.375 1.375 0 0 0 0-2.75h-1a.625.625 0 1 1 0-1.25h1a1.375 1.375 0 0 0 0-2.75h-7.834c.618-1.617 1.2-3.359 1.497-4.742.276-1.28-.77-2.258-1.93-2.258ZM3.5 8.815a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v12.5a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c = { render: t };
export {
  c as default,
  t as render
};
